// src/App.jsx
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import Construction from './pages/Construction';

function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/construcao" element={<Construction />} />
    </Routes>
  );
}

export default App;
